import { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'AuthContext';


function Logout() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const runOnce = useRef(false);

  useEffect(() => {
    if (runOnce.current) return;
    runOnce.current = true;
    logout();
    navigate('/', { replace: true });
  }, [logout, navigate]);

  return null;
}
export default Logout;